import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

export const committeeSchema = z.object({
  title: z.string().min(3),
  startYear: z.number(),
  endYear: z.number().nullable(),
  type: identitySchema.nullable().refine((value): boolean => value !== null, { params: { i18n: 'custom.required' } }),
  authors: z.array(authorSchema),
});

export const defaultCommitteeValues: DefaultValues<CommitteeSchema> = {
  title: '',
  endYear: new Date().getFullYear(),
  type: null,
};

export type CommitteeSchema = z.infer<typeof committeeSchema>;
